//
// faculty member list(JS)
// 2019-08-20
// Space-Time Inc.
//
jQuery(function($) {
	$(function() {
		var $tags = $(".faculty-member-anchor-list >li > a");
		var $lists = $(".swiching-list");

		var href_id = location.hash;

		var $tTag = $tags.filter('[href="' + href_id + '"]');

		if ($tTag[0]) {
			facultyMemberControl($tTag, href_id);
		}

		$tags.click(function() {
			var href_id = $(this).attr("href");
			facultyMemberControl($(this), href_id);
		});

		function facultyMemberControl($targetTag, tid) {
			if (tid == "#all-list") {
				$lists.parent().css("display", "");
				$lists.parent().removeClass("non-display");

				$tags.parent().removeClass("current");
				$targetTag.parent().addClass("current");
			} else {
				var $target_list = $(tid);
				$lists.parent().css("display", "none");
				$lists.parent().addClass("non-display");
				$target_list.parent().css("display", "");
				$target_list.parent().removeClass("non-display");

				$tags.parent().removeClass("current");
				$targetTag.parent().addClass("current");
			}
		}
	});
});
